<template>
	<div class="select">
		<select v-model="id">
			<option :value="0">-</option>
			<option
				v-for="option in healthservices"
				:key="option.id"
				:value="option.id"
				v-text="option.name"
			/>
		</select>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "HealthServiceFilter",
	computed: {
		...mapGetters({
			healthservices: "reportFilters/healthservices",
			healthserviceID: "reportQueries/healthserviceID"
		}),
		id: {
			get() {
				return this.healthserviceID;
			},
			set(id) {
				this.setID(id);
			}
		}
	},
	async created() {
		if (!this.healthservices.length) {
			await this.fetch();
			const { id } = this.healthservices[0];
			this.id = id;
		}
	},
	methods: {
		...mapActions({
			fetch: "reportFilters/fetchHealthServices",
			setID: "reportQueries/updateHealthServiceID"
		})
	}
};
</script>

<style></style>
